/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationScheduleRequestFilter {
    getFixupPrototypeFunction() { return ScheduleRecommendationScheduleRequestFilter.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationScheduleRequestFilter>): ScheduleRecommendationScheduleRequestFilter {
        let obj = Object.assign(new ScheduleRecommendationScheduleRequestFilter(), model);
        ScheduleRecommendationScheduleRequestFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationScheduleRequestFilter>): ScheduleRecommendationScheduleRequestFilter {
        if (!model) return null;
        return ScheduleRecommendationScheduleRequestFilter.newInstance(<ScheduleRecommendationScheduleRequestFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationScheduleRequestFilter) {
        if (!obj) return;

        models.ScheduleRecommendationScheduleRequestFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationScheduleRequestFilter): boolean {
        Object.setPrototypeOf(obj, ScheduleRecommendationScheduleRequestFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.estimate_minimum === undefined) {
            this.estimate_minimum = 0;
        }
        if (this.estimate_maximum === undefined) {
            this.estimate_maximum = 0;
        }
    }

    /**
     * Minimum Estimated Cost to Filter
     */
    estimate_minimum: number;

    /**
     * Maximum Estimated Cost to Filter
     */
    estimate_maximum: number;

}
